export default __webpack_public_path__ + "static/media/photo--sm--wheel-6.5eae8a36.jpg";